<template>
    <li :class="class" class="product product-card" ref="card">
        <slot></slot>
    </li>
</template>
<script setup>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onMounted, ref } from 'vue';

const props = defineProps(['class'])
const card = ref(null);

gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

onMounted(() => {


    const images = card.value.querySelector('.images');

    mm.add('(min-width:768px)', () => {
        let tl = new gsap.timeline({
            scrollTrigger:{
                trigger:card.value,
                start(){
                    return 'top center+=' + (document.querySelector('header.main').offsetHeight+32)
                }
            },
            duration:0.3,
            ease:'power1.in',
        });

        tl.from(card.value.querySelector('.copy'), {
            autoAlpha:0
        });

        if(images.classList.contains('odd')){
            tl.from(images.querySelector('.stick'), {
                x:'100%',
                autoAlpha:0
            }, 0.3);
        } else {
            tl.from(images.querySelector('.stick'), {
                x:'-100%',
                autoAlpha:0
            }, 0.3);
        }
        tl.from(images.querySelector('.photo'), {
            scale:0,
        }, 0.2);

    })

    mm.add('(max-width:767px)', () => {
        let tl = new gsap.timeline({
            scrollTrigger:{
                trigger:card.value,
                start(){
                    return 'top center+=' + (document.querySelector('header.main').offsetHeight+32)
                }
            },
            duration:0.3,
            ease:'power1.in',
        });

        tl.from(card.value.querySelector('.copy'), {
            autoAlpha:0
        })
        tl.from(images.querySelector('.stick'), {
            y:'10%',
            autoAlpha:0
        }, 0.3);
        tl.from(images.querySelector('.photo'), {
            scale:0
        }, 0.2);


    });

    window.addEventListener('resize', ()=>{
        ScrollTrigger.refresh();
    }, true)



})
</script>
